/** Largeur minimale pour le parcours candidat (plateau 1280×720). */
export const MIN_PLAYER_WIDTH_PX = 1024;

export const isMobileUserAgent = () => {
  if (typeof navigator === "undefined") return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(
    navigator.userAgent,
  );
};

export const requiresDesktopForPlayer = () => {
  if (typeof window === "undefined") return false;
  if (window.innerWidth < MIN_PLAYER_WIDTH_PX) return true;
  return isMobileUserAgent() && window.innerWidth < 1280;
};
